export default __webpack_public_path__ + "static/media/premium.f7459b30.webp";